import React from 'react';
import parse from 'html-react-parser';

import classNames from 'classnames';
import { resolveSetting } from '../../../utils/settingsHelper';
import { toSafeFontName } from '../../../utils/fonts';
import { fontSizeClasses, mobileOnlyFontSizeClasses, desktopOnlyFontSizeClasses } from '../../editor/Toolbar/options';

export const getFontSizeClasses = (fontSize, mobileFontSize) => {
	if (!fontSize) {
		return '';
	}

	const desktop = Math.min(Math.max(parseInt(fontSize, 10), 5), 200);

	if (!mobileFontSize) {
		return fontSizeClasses[desktop];
	}

	const mobile = Math.min(Math.max(parseInt(mobileFontSize, 10), 0), 200);
	return `${mobileOnlyFontSizeClasses[mobile]} ${desktopOnlyFontSizeClasses[desktop]}`;
};

export const getLineHeight = (fontSize) => {
	const size = parseInt(fontSize, 10);
	if (!size || size <= 20) return 1.5;
	if (size <= 32) return 1.3;
	if (size <= 48) return 1.2;
	if (size <= 100) return 1.1;
	return 1.05;
};

export const getTextStyle = (props, settings) => {
	const {
		textAlign,
		fontWeight,
		color,
		color2,
		color3,
		shadow,
		display,
		fontFamily,
		useHeadingFontFamily,
	} = props;

	const hasGradient = resolveSetting(color2, settings);
	let gradientBackground = null;
	if (hasGradient) {
		const colors = [
			resolveSetting(color, settings),
			resolveSetting(color2, settings),
		];
		if (resolveSetting(color3, settings)) {
			colors.push(resolveSetting(color3, settings));
		}
		gradientBackground = `-webkit-linear-gradient(left, ${colors.join(', ')}) text`;
	}

	return {
		width: 'auto',
		color: hasGradient ? 'transparent' : resolveSetting(color, settings),
		...(hasGradient ? { background: gradientBackground } : {}),
		...(hasGradient ? { WebkitBackgroundClip: 'text' } : {}),
		...(hasGradient ? { WebkitTextClip: 'background !important' } : {}),
		textShadow: `0px 0px 2px rgba(0,0,0,${(shadow || 0) / 100})`,
		fontWeight,
		textAlign,
		lineHeight: getLineHeight(resolveSetting(props.fontSize, settings)),
		whiteSpace: 'pre-wrap',
		overflowWrap: 'break-word',
		fontFamily: toSafeFontName(resolveSetting(fontFamily, settings)) || (useHeadingFontFamily && settings.headingFontFamily ? toSafeFontName(settings.headingFontFamily) : undefined) || toSafeFontName(settings?.fontFamily) || undefined,
		display,
	};
};

export function Text({
	settings,
	className,
	text,
	tag = 'p',
	...props
}) {
	const count = (text.match(/<p>/g) || []).length;

	const finalText = count > 1 ? text : text.replace('<p>', '<span>').replace('</p>', '</span>');

	const Tag = count > 1 || ['ul', 'li', 'div', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].some((i) => finalText.includes(`<${i}>`)) ? 'div' : tag;

	return (
		<Tag
			className={classNames('ck-content', getFontSizeClasses(resolveSetting(props.fontSize, settings), resolveSetting(props.mobileFontSize, settings)))}
			style={getTextStyle(props, settings)}
		>
			{parse(count > 1 ? text : text.replace('<p>', '<span>').replace('</p>', '</span>'))}
		</Tag>
	);
}
